// extracted by mini-css-extract-plugin
export default {"addRule":"AddRule_addRule__zjTgb"};